import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { useApi } from '#src/api/index.ts';

export const useSearchResults = (searchTerm: string) => {
  // Search is logged out
  const api = useApi({ dangerouslyDefeatAuth: true });

  const { data, isLoading, isRefetching, isError } = useQuery({
    queryKey: ['search', searchTerm, api],
    queryFn: async ({ signal }) => {
      if (searchTerm.length === 0) {
        return [];
      }
      // Poor-mans debouncing. This is so we can show that we're "loading" while they're still typing,
      // and between finishing typing and the API call, so that results don't just slide in
      await new Promise((resolve) => setTimeout(resolve, 300));
      if (signal.aborted) {
        return [];
      }

      return api.siteSearch.get(searchTerm, signal);
    },
    placeholderData: keepPreviousData,
    staleTime: Infinity,
  });

  return {
    data,
    isLoading: searchTerm.length === 0 ? false : isLoading || isRefetching,
    isError,
  };
};
